var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('GenericListTable',{attrs:{"parentID":this.parentID,"title":"Groups","headers":[
        { text: 'ID', value: 'id' },
        { text: 'Group Code', value: 'co_groupcode' },
        { text: 'Group Description', value: 'co_groupdesc' },
        { text: 'Group Name', value: 'co_groupname' }
      ],"url":"/manifest/groupinfo","apiResponseField":"groupinfolist","onClickRoute":"GroupSingle","onClickParams":_vm.getOnClickParams,"editable":true,"saveUrl":"/manifest/groupinfo?ids_to_update="}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }